module.exports = __webpack_public_path__ + "static/media/F_foto.7f37fdbf.svg";